// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAllFromOfficialRepresentativeSchema } from '../all_from_official_representative/AllFromOfficialRepresentativeSchema';
import type { IAreaPartPropPresenterSchema } from '../area_part_prop_presenter/AreaPartPropPresenterSchema';
import type { IBargainTermsPresenterSchema } from '../bargain_terms_presenter/BargainTermsPresenterSchema';
import type { IBookingInfoPresenterSchema } from '../booking_info_presenter/BookingInfoPresenterSchema';
import type { IBuildingPresenterSchema } from '../building_presenter/BuildingPresenterSchema';
import type { IBusinessShoppingCenterSchema } from '../business_shopping_center/BusinessShoppingCenterSchema';
import type { ICommunicationSchema } from '../communication/CommunicationSchema';
import type { ICoworkingPresenterSchema } from '../coworking_presenter/CoworkingPresenterSchema';
import type { ICplModerationSchema } from '../cpl_moderation/CplModerationSchema';
import type { IDistrictBtiDataSchema } from '../district_bti_data/DistrictBtiDataSchema';
import type { IDrainageSchema } from '../drainage/DrainageSchema';
import type { IElectricitySchema } from '../electricity/ElectricitySchema';
import type { IFlagsSchema } from '../flags/FlagsSchema';
import type { IGarageSchema } from '../garage/GarageSchema';
import type { IGasSchema } from '../gas/GasSchema';
import type { IGeoPresenterListItemSchema } from '../geo_presenter_list_item/GeoPresenterListItemSchema';
import type { IKpSchema } from '../kp/KpSchema';
import type { ILandSchema } from '../land/LandSchema';
import type { IPhotoSchema } from '../photo/PhotoSchema';
import type { IMonthlyIincomeSchema } from '../monthly_iincome/MonthlyIincomeSchema';
import type { IMultipostingSchema } from '../multiposting/MultipostingSchema';
import type { INewBuildingPresenterSchema } from '../new_building_presenter/NewBuildingPresenterSchema';
import type { INewbuildingDynamicCalltrackingSchema } from '../newbuilding_dynamic_calltracking/NewbuildingDynamicCalltrackingSchema';
import type { IUserNotesSchema } from '../user_notes/UserNotesSchema';
import type { IPhoneOfferPresenterSchema } from '../phone_offer_presenter/PhoneOfferPresenterSchema';
import type { IPublicOfferPhotoPresenterSchema } from '../public_offer_photo_presenter/PublicOfferPhotoPresenterSchema';
import type { IPlatformObjectSchema } from '../platform_object/PlatformObjectSchema';
import type { IPriceChangePresenterSchema } from '../price_change_presenter/PriceChangePresenterSchema';
import type { IPromoInfoSchema } from '../promo_info/PromoInfoSchema';
import type { IPublishTermsSchema } from '../publish_terms/PublishTermsSchema';
import type { IOfferRosreestrCheckSchema } from '../offer_rosreestr_check/OfferRosreestrCheckSchema';
import type { ISelfEmployedDataSchema } from '../self_employed_data/SelfEmployedDataSchema';
import type { ISimilarOffersSchema } from '../similar_offers/SimilarOffersSchema';
import type { ICommercialSpecialtySchema } from '../commercial_specialty/CommercialSpecialtySchema';
import type { IStatisticSchema } from '../statistic/StatisticSchema';
import type { IFastFiltersUserPresenterSchema } from '../fast_filters_user_presenter/FastFiltersUserPresenterSchema';
import type { IVideoSchema } from '../video/VideoSchema';
import type { IWaterSchema } from '../water/WaterSchema';
import type { IWorkTimeInfoPresenterSchema } from '../work_time_info_presenter/WorkTimeInfoPresenterSchema';

export interface IFastFiltersOfferPresenterSchema {
  /** Доступ **/
  accessType?: EAccessType;
  /** Дата подачи объявления **/
  added?: string;
  /** Дата подачи объявления (timestamp) **/
  addedTimestamp?: number;
  /** Доп. линии **/
  additionalPhoneLinesAllowed?: boolean;
  /** Данные об объявлениях от офпреда в ТЦ/БЦ пирвязанном к этому объявлению **/
  allFromOffrep?: IAllFromOfficialRepresentativeSchema;
  /** Площадь комнат, м2 **/
  allRoomsArea?: string;
  /** Дата перемещения объявления в архив **/
  archivedDate?: string;
  /** Части площади **/
  areaParts?: IAreaPartPropPresenterSchema[];
  /** Дата освобождения **/
  availableFrom?: string;
  /** Количество балконов **/
  balconiesCount?: number;
  /** Условия сделки **/
  bargainTerms?: IBargainTermsPresenterSchema;
  /** Количество спален **/
  bedroomsCount?: number;
  /** Количество спальных мест **/
  bedsCount?: number;
  /** Информация о бронировании **/
  booking?: IBookingInfoPresenterSchema;
  /** Уровень брендинга **/
  brandingLevel?: boolean;
  /** Информация о доме **/
  building?: IBuildingPresenterSchema;
  /** Кадастровый номер дома **/
  buildingCadastralNumber?: string;
  /** БЦ/ТЦ **/
  businessShoppingCenter?: IBusinessShoppingCenterSchema;
  /** Кадастровый номер **/
  cadastralNumber?: string;
  /** Тип подключенного calltracking-а **/
  callTrackingProvider?: ECallTrackingProvider;
  /** Можно частями **/
  canParts?: boolean;
  /** Категории **/
  categoriesIds?: number[];
  /** Категория объявления **/
  category: ECategory;
  /** Идентификатор чата **/
  chatId?: string;
  /** Можно с детьми **/
  childrenAllowed?: boolean;
  /** ID объявления на ЦИАНе **/
  cianId?: number;
  /** ID пользователя в ЦИАНе **/
  cianUserId?: number;
  /** Количество совместных санузлов **/
  combinedWcsCount?: number;
  /** Виды коммуникации с пользователем **/
  communication?: ICommunicationSchema;
  /** Состояние **/
  conditionRatingType?: EConditionRatingType;
  /** Состояние **/
  conditionType?: EConditionType;
  /** Информация о коворкинге **/
  coworking?: ICoworkingPresenterSchema;
  /** Тип помещения в коворкинге **/
  coworkingOfferType?: ECoworkingOfferType;
  /** Информация для проверки агента по CPL-схеме **/
  cplModeration?: ICplModerationSchema;
  /** Тип сделки **/
  dealType?: EDealType;
  /** Отделка **/
  decoration?: EDecoration;
  /** Дом подлежит сносу в рамках программы реновации **/
  demolishedInMoscowProgramm?: boolean;
  /** Текст объявления **/
  description?: string;
  /** Minhash текста объявления **/
  descriptionMinhash?: string;
  /** Список диапазонов подсвеченных слов **/
  descriptionWordsHighlighted?: number[][];
  /** Информация о районе **/
  district?: IDistrictBtiDataSchema;
  /** Канализация **/
  drainage?: IDrainageSchema;
  /** Объем, м3/сутки **/
  drainageCapacity?: number;
  /** Тип канализации **/
  drainageType?: EDrainageType;
  /** Подъездные пути **/
  drivewayType?: EDrivewayType;
  /** ID группы дубликатов объявлений **/
  duplicateGroupId?: number;
  /** Дата смены статуса объявления **/
  editDate?: string;
  /** Электроснабжение **/
  electricity?: IElectricitySchema;
  /** Мощность, кВТ **/
  electricityPower?: number;
  /** Тип электроснабжения **/
  electricityType?: EElectricityType;
  /** Недвижимость **/
  estateType?: EEstateType;
  /** Ссылки для скачивания оффера в виде DOC **/
  exportDocLink?: string;
  /** Ссылки для скачивания оффера в виде PDF **/
  exportPdfLink?: string;
  /** Внешний ID **/
  externalId?: string;
  /** Ссылка на оригинальное объявление **/
  externalUrl?: string;
  /** Id склеенных объявлений **/
  feedboxMultiOfferKey?: string;
  /** Флаги состояния объявления **/
  flags?: IFlagsSchema;
  /** Тип квартиры **/
  flatType?: EFlatType;
  /** Этаж с **/
  floorFrom?: number;
  /** Материал полов **/
  floorMaterialType?: EFloorMaterialType;
  /** Этаж **/
  floorNumber?: number;
  /** Этаж по **/
  floorTo?: number;
  /** От застройщика (аккаунт объявления с тарифом Застройщик) **/
  fromDeveloper?: boolean;
  /** Ссылка на объявление **/
  fullUrl?: string;
  /** Мебель **/
  furniture?: string;
  /** Мебель **/
  furniturePresence?: EFurniturePresence;
  /** Google analytics label **/
  gaLabel?: string;
  /** Тип гаража **/
  garage?: IGarageSchema;
  /** Газоснабжение **/
  gas?: IGasSchema;
  /** Емкость, м3/час **/
  gasCapacity?: number;
  /** Давление, Мпа **/
  gasPressure?: number;
  /** Тип газоснабжения **/
  gasType?: EGasType;
  /** Представление гео элементов **/
  geo?: IGeoPresenterListItemSchema;
  /** Есть баня **/
  hasBathhouse?: boolean;
  /** Есть ванна **/
  hasBathtub?: boolean;
  /** Заселение 24 часа **/
  hasCheckIn_24?: boolean;
  /** Есть кондиционер **/
  hasConditioner?: boolean;
  /** Есть посудомоечная машина **/
  hasDishwasher?: boolean;
  /** Есть канализация **/
  hasDrainage?: boolean;
  /** Есть электричество **/
  hasElectricity?: boolean;
  /** Есть обременение **/
  hasEncumbrances?: boolean;
  /** Есть оборудование **/
  hasEquipment?: boolean;
  /** Организация экскурсий **/
  hasExcursions?: boolean;
  /** Есть система пожаротушения **/
  hasExtinguishingSystem?: boolean;
  /** Есть холодильник **/
  hasFridge?: boolean;
  /** Есть мебель (в комнатах для живой) **/
  hasFurniture?: boolean;
  /** Есть гараж **/
  hasGarage?: boolean;
  /** Есть газ **/
  hasGas?: boolean;
  /** Фен **/
  hasHairdryer?: boolean;
  /** Есть отопление **/
  hasHeating?: boolean;
  /** Есть интернет **/
  hasInternet?: boolean;
  /** Есть инвестпроект **/
  hasInvestmentProject?: boolean;
  /** Утюг **/
  hasIron?: boolean;
  /** Джакузи **/
  hasJacuzzi?: boolean;
  /** Есть мебель на кухне **/
  hasKitchenFurniture?: boolean;
  /** Есть лифт **/
  hasLift?: boolean;
  /** Есть свет **/
  hasLight?: boolean;
  /** Есть парковка **/
  hasParking?: boolean;
  /** Есть телефон **/
  hasPhone?: boolean;
  /** Есть бассейн **/
  hasPool?: boolean;
  /** Пандус (есть/нет) **/
  hasRamp?: boolean;
  /** Ответственное хранение **/
  hasSafeCustody?: boolean;
  /** Документы командированным **/
  hasSecondedDocs?: boolean;
  /** Есть охрана **/
  hasSecurity?: boolean;
  /** Есть витринные окна **/
  hasShopWindows?: boolean;
  /** Есть душевая кабина **/
  hasShower?: boolean;
  /** Чай-кофе-сахар **/
  hasTeaCoffeeSugar?: boolean;
  /** Трансфер **/
  hasTransfer?: boolean;
  /** Транспортные услуги **/
  hasTransportServices?: boolean;
  /** Есть телевизор **/
  hasTv?: boolean;
  /** Есть стиральная машина **/
  hasWasher?: boolean;
  /** Есть водоснабжение **/
  hasWater?: boolean;
  /** Есть Wi-Fi **/
  hasWifi?: boolean;
  /** Платные ТВ-каналы **/
  hasWiredInternet?: boolean;
  /** Список всех проверок, которые прошел пользователь **/
  homeownerProofs?: EHomeownerProofs[];
  /** Относительная дата подачи объявления **/
  humanizedTimedelta?: string;
  /** ID объявления в Realty **/
  id?: number;
  /** Вход **/
  inputType?: EInputType;
  /** Апартаменты **/
  isApartments?: boolean;
  /** Аукцион **/
  isAuction?: boolean;
  /** Объявление от собственника коммерческой **/
  isByCommercialOwner?: boolean;
  /** Объявление от собственника **/
  isByHomeowner?: boolean;
  /** Объявление от партнера **/
  isCianPartner?: boolean;
  /** Выделение цветом **/
  isColorized?: boolean;
  /** Таможня **/
  isCustoms?: boolean;
  /** Дача **/
  isDacha?: boolean;
  /** Подменяли ли номер застройщика для сделки **/
  isDealRequestSubstitutionPhone?: boolean;
  /** Дубликат или оригинал **/
  isDuplicate?: boolean;
  /** Дублирующееся описание **/
  isDuplicatedDescription?: boolean;
  /** Подключен ли колтрекинг **/
  isEnabledCallTracking?: boolean;
  /** Флаг пессимизации, в объявлении встречаются ошибки **/
  isExcludedFromAction?: boolean;
  /** Работаем честно **/
  isFairplay?: boolean;
  /** В избранном **/
  isFavorite?: boolean;
  /** Является ли объявлением от застройщика (застройщик, не представитель) **/
  isFromBuilder?: boolean;
  /** Скрыто ли объявление пользователем **/
  isHiddenByUser?: boolean;
  /** Из импорта ли объявление **/
  isImported?: boolean;
  /** Объявление закрытой базы **/
  isInHiddenBase?: boolean;
  /** Юр. адрес предоставляется (да/нет) **/
  isLegalAddressProvided?: boolean;
  /** Является ли объявление мультиофером **/
  isMulti?: boolean;
  /** Скрывать точный адрес для отображения **/
  isNeedHideExactAddress?: boolean;
  /** Нужно добавить иконку "Новое" **/
  isNew?: boolean;
  /** Помещение занято **/
  isOccupied?: boolean;
  /** Платное **/
  isPaid?: boolean;
  /** Пентхаус **/
  isPenthouse?: boolean;
  /** Премиум **/
  isPremium?: boolean;
  /** Значок профессионала **/
  isPro?: boolean;
  /** Включена ли возможность показов **/
  isRealtyDemonstrationEnabled?: boolean;
  /** Флаг пессимизации, рецидивист **/
  isRecidivist?: boolean;
  /** Сдается ли в аренду частями **/
  isRentByParts?: boolean;
  /** Стандарт **/
  isStandard?: boolean;
  /** Топ **/
  isTop3?: boolean;
  /** Ссылка на ЖК **/
  jkUrl?: string;
  /** Площадь кухни, м2 **/
  kitchenArea?: number;
  /** Коттеджный поселок **/
  kp?: IKpSchema;
  /** Информация об участке **/
  land?: ILandSchema;
  /** Планировка **/
  layout?: ELayout;
  /** Планировка **/
  layoutPhoto?: IPhotoSchema;
  /** Инфраструктура и досуг **/
  leisure?: string;
  /** Жилая площадь, м2 **/
  livingArea?: number;
  /** Количество лоджий **/
  loggiasCount?: number;
  /** Максимальная площадь **/
  maxArea?: number;
  /** Площадь от **/
  minArea?: number;
  /** Минимальная цена за весь объект **/
  minPriceTotal?: number;
  /** Минимальная цена за весь объект в месяц **/
  minPriceTotalPerMonth?: number;
  /** Цена за весь объект за минимальную возможную площадь в месяц в рублях **/
  minPriceTotalPerMonthRur?: number;
  /** Цена за весь объект в месяц за минимальную возможную площадь для поиска **/
  minPriceTotalPerMonthRurForSearch?: number;
  /** Цена за весь объект за минимальную возможную площадь в рублях **/
  minPriceTotalRur?: number;
  /** Цена за весь объект за минимальную возможную площадь для поиска **/
  minPriceTotalRurForSearch?: number;
  /** НДС за весь объект в месяц за минимальную возможную площадь **/
  minVatPriceTotalPerMonthRur?: number;
  /** НДС за весь объект за минимальную возможную площадь **/
  minVatPriceTotalRur?: number;
  /** Месячная прибыль **/
  monthlyIncome?: IMonthlyIincomeSchema;
  /** Информация о Мультипостинге **/
  multiposting?: IMultipostingSchema;
  /** Наименование **/
  name?: string;
  /** Объект NewBuilding **/
  newbuilding?: INewBuildingPresenterSchema;
  /** Данные о динамическом calltracking новостроек **/
  newbuildingDynamicCalltracking?: INewbuildingDynamicCalltrackingSchema;
  /** Текст промо **/
  newobjectPromoLabel?: string;
  /** Заметки пользователя **/
  notes?: IUserNotesSchema;
  /** Временный ID объявления/черновика (GUID) **/
  objectGuid: string;
  /** Тип недвижимости **/
  offerType?: EOfferType;
  /** Вид разрешенного использования (ВРИ) **/
  permittedUseType?: EPermittedUseType;
  /** Можно с животными **/
  petsAllowed?: boolean;
  /** Кол-во телефонных линий **/
  phoneLinesCount?: number;
  /** Нормализованный номер телефона **/
  phones?: IPhoneOfferPresenterSchema[];
  /** Фотографии **/
  photos?: IPublicOfferPhotoPresenterSchema[];
  /** Тип помещения **/
  placementType?: EPlacementType;
  /** Платформа подачи объявления **/
  platform?: IPlatformObjectSchema;
  /** Возможно изменить ВРИ **/
  possibleToChangePermittedUseType?: boolean;
  /** История изменения цены **/
  priceChanges?: IPriceChangePresenterSchema[];
  /** Цена за единицу площади **/
  pricePerUnitArea?: number;
  /** Цена за единицу площади **/
  pricePerUnitAreaEur?: number;
  /** Цена за кв.м. в месяц **/
  pricePerUnitAreaPerMonth?: number;
  /** Цена за кв.м. в месяц (руб) **/
  pricePerUnitAreaPerMonthRur?: number;
  /** Цена за кв.м. в месяц (руб) для поиска **/
  pricePerUnitAreaPerMonthRurForSearch?: number;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYear?: number;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearEur?: number;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearRur?: number;
  /** Цена за кв.м. в год для поиска **/
  pricePerUnitAreaPerYearRurForSearch?: number;
  /** Цена за кв.м. в год **/
  pricePerUnitAreaPerYearUsd?: number;
  /** Цена за единицу площади **/
  pricePerUnitAreaRur?: number;
  /** Цена за единицу площади для поиска **/
  pricePerUnitAreaRurForSearch?: number;
  /** Цена за единицу площади **/
  pricePerUnitAreaUsd?: number;
  /** Максимальная цена **/
  priceTotal?: number;
  /** Цена за весь объект **/
  priceTotalEur?: number;
  /** Максимальная цена в месяц **/
  priceTotalPerMonth?: number;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthEur?: number;
  /** Максимальная цена в месяц в рублях **/
  priceTotalPerMonthRur?: number;
  /** Цена за весь объект в месяц для поиска **/
  priceTotalPerMonthRurForSearch?: number;
  /** Цена за весь объект в месяц **/
  priceTotalPerMonthUsd?: number;
  /** Максимальная цена в рублях **/
  priceTotalRur?: number;
  /** Цена за весь объект для поиска **/
  priceTotalRurForSearch?: number;
  /** Цена за весь объект **/
  priceTotalUsd?: number;
  /** Количество дублей в группе профпоиска **/
  professionalSearchDuplicatesGroupSize?: number;
  /** Проектная декларация **/
  projectDeclarationUrl?: string;
  /** Рекламные акции **/
  promoInfo?: IPromoInfoSchema;
  /** Тип недвижимости **/
  propertyType?: EPropertyType;
  /** Условия размещения объявления **/
  publishTerms?: IPublishTermsSchema;
  /** Realty ID пользователя, из под которого показывается объявление **/
  publishedUserId?: number;
  /** Тип готового бизнеса **/
  readyBusinessType?: EReadyBusinessType;
  /** Описание сдачи части в аренду **/
  rentByPartsDescription?: string;
  /** Тип ремонта **/
  repairType?: ERepairType;
  /** Площадь комнаты (комната, койко-место) **/
  roomArea?: number;
  /** Тип комнаты (комната) **/
  roomType?: ERoomType;
  /** Площадь комнат **/
  roomsArea?: number;
  /** Количество комнат **/
  roomsCount?: number;
  /** Количество комнат в продажу/аренду **/
  roomsForSaleCount?: number;
  /** Статус проверки в росреестре **/
  rosreestrCheck?: IOfferRosreestrCheckSchema;
  /** Данные по самозанятому пользователю **/
  selfEmployedData?: ISelfEmployedDataSchema;
  /** Количество раздельных санузлов **/
  separateWcsCount?: number;
  /** Название коттеджного поселка **/
  settlementName?: string;
  /** Размер доли (доля в квартире, доля в доме) **/
  shareAmount?: string;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: boolean;
  /** Querystring объявлений в этом доме **/
  similar?: ISimilarOffersSchema;
  /** Возможное назначение **/
  specialty?: ICommercialSpecialtySchema;
  /** Статистика **/
  statistic?: IStatisticSchema;
  /** Статус объявления **/
  status: EStatus;
  /** Номер налоговой **/
  taxNumber?: number;
  /** Заголовок объявления **/
  title?: string;
  /** Общая площадь, м2 **/
  totalArea?: number;
  /** Информация о пользователе **/
  user?: IFastFiltersUserPresenterSchema;
  /** ID пользователя в Realty **/
  userId?: number;
  /** Тип ML ранжирования **/
  vasType?: EVasType;
  /** НДС за весь объект в месяц **/
  vatPriceTotalPerMonthRur?: number;
  /** НДС за весь объект **/
  vatPriceTotalRur?: number;
  /** Список добавленных видео **/
  videos?: IVideoSchema[];
  /** Сельская ипотека **/
  villageMortgageAllowed?: boolean;
  /** Водоснабжение **/
  water?: IWaterSchema;
  /** Объем, м3/сутки **/
  waterCapacity?: number;
  /** Кол-во мокрых точек **/
  waterPipesCount?: number;
  /** Тип водоснабжения **/
  waterType?: EWaterType;
  /** Расположение санузла **/
  wcLocationType?: EWcLocationType;
  /** Тип санузла (комната) **/
  wcType?: EWcType;
  /** Куда выходят окна **/
  windowsViewType?: EWindowsViewType;
  /** Наличие коммиссии в пользу риэлтора за заключение договора для аредатора **/
  withoutClientFee?: boolean;
  /** Часы работы **/
  workTimeInfo?: IWorkTimeInfoPresenterSchema;
  /** Количество рабочих мест в помещении **/
  workplaceCount?: number;
}
export enum EAccessType {
  /** Свободный **/
  'Free' = 'free',
  /** Пропускная система **/
  'PassSystem' = 'passSystem',
}
export enum ECallTrackingProvider {
  /** Билайн **/
  'Beeline' = 'beeline',
  /** МТС **/
  'Mts' = 'mts',
  /** MTT **/
  'Mtt' = 'mtt',
}
export enum ECategory {
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
}
export enum EConditionRatingType {
  /** Отличное **/
  'Excellent' = 'excellent',
  /** Хорошее **/
  'Good' = 'good',
  /** Удовлетворительное **/
  'Satisfactory' = 'satisfactory',
}
export enum EConditionType {
  /** Требуется косметический ремонт **/
  'CosmeticRepairsRequired' = 'cosmeticRepairsRequired',
  /** Дизайнерский ремонт **/
  'Design' = 'design',
  /** Под чистовую отделку **/
  'Finishing' = 'finishing',
  /** Требуется капитальный ремонт **/
  'MajorRepairsRequired' = 'majorRepairsRequired',
  /** Офисная отделка **/
  'Office' = 'office',
  /** Типовой ремонт **/
  'Typical' = 'typical',
}
export enum ECoworkingOfferType {
  /** Конференц-зал **/
  'ConferenceHall' = 'conferenceHall',
  /** Закрепленное рабочее место **/
  'FixedWorkplace' = 'fixedWorkplace',
  /** Незакрепленное рабочее место **/
  'FlexibleWorkplace' = 'flexibleWorkplace',
  /** Переговорная комната **/
  'MeetingRoom' = 'meetingRoom',
  /** Офис **/
  'Office' = 'office',
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EDecoration {
  /** Чистовая **/
  'Fine' = 'fine',
  /** Черновая **/
  'Rough' = 'rough',
  /** Без отделки **/
  'Without' = 'without',
}
export enum EDrainageType {
  /** Автономная **/
  'Autonomous' = 'autonomous',
  /** Центральная **/
  'Central' = 'central',
  /** Выгребная яма **/
  'Cesspool' = 'cesspool',
  /** Септик **/
  'SepticTank' = 'septicTank',
  /** Ливневая **/
  'Storm' = 'storm',
  /** Очистные сооружения **/
  'TreatmentFacilities' = 'treatmentFacilities',
}
export enum EDrivewayType {
  /** Асфальтированная дорога **/
  'Asphalt' = 'asphalt',
  /** Грунтовая дорога **/
  'Ground' = 'ground',
  /** Нет **/
  'No' = 'no',
}
export enum EElectricityType {
  /** По границе участка **/
  'Border' = 'border',
  /** На участке **/
  'Location' = 'location',
  /** Нет **/
  'No' = 'no',
}
export enum EEstateType {
  /** В собственности **/
  'Owned' = 'owned',
  /** В аренде **/
  'Rent' = 'rent',
}
export enum EFlatType {
  /** Свободная планировка **/
  'OpenPlan' = 'openPlan',
  /** Комнаты **/
  'Rooms' = 'rooms',
  /** Студия **/
  'Studio' = 'studio',
}
export enum EFloorMaterialType {
  /** Асфальт **/
  'Asphalt' = 'asphalt',
  /** Бетон **/
  'Concrete' = 'concrete',
  /** Ламинат **/
  'Laminate' = 'laminate',
  /** Линолеум **/
  'Linoleum' = 'linoleum',
  /** Полимерный **/
  'Polymeric' = 'polymeric',
  /** Железобетон **/
  'ReinforcedConcrete' = 'reinforcedConcrete',
  /** Наливной пол **/
  'SelfLeveling' = 'selfLeveling',
  /** Плитка **/
  'Tile' = 'tile',
  /** Дерево **/
  'Wood' = 'wood',
}
export enum EFurniturePresence {
  /** Нет **/
  'No' = 'no',
  /** По желанию **/
  'Optional' = 'optional',
  /** Есть **/
  'Yes' = 'yes',
}
export enum EGasType {
  /** По границе участка **/
  'Border' = 'border',
  /** На участке **/
  'Location' = 'location',
  /** Нет **/
  'No' = 'no',
}
export enum EHomeownerProofs {
  /** Паспорт **/
  'Passport' = 'passport',
  /** Пользователь прошел проверку в Росреестре **/
  'Rosreestr' = 'rosreestr',
  /** Пользователь сдает как самозанятый **/
  'SelfEmployed' = 'selfEmployed',
}
export enum EInputType {
  /** Общий с улицы **/
  'CommonFromStreet' = 'commonFromStreet',
  /** Общий со двора **/
  'CommonFromYard' = 'commonFromYard',
  /** Отдельный с улицы **/
  'SeparateFromStreet' = 'separateFromStreet',
  /** Отдельный со двора **/
  'SeparateFromYard' = 'separateFromYard',
}
export enum ELayout {
  /** Кабинетная **/
  'Cabinet' = 'cabinet',
  /** Коридорная **/
  'Corridorplan' = 'corridorplan',
  /** Смешанная **/
  'Mixed' = 'mixed',
  /** Открытая **/
  'OpenSpace' = 'openSpace',
}
export enum EOfferType {
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** квартиры **/
  'Flat' = 'flat',
  /** новостройки **/
  'Newobject' = 'newobject',
  /** загородка **/
  'Suburban' = 'suburban',
}
export enum EPermittedUseType {
  /** Cельскохозяйственное использование **/
  'Agricultural' = 'agricultural',
  /** Деловое управление **/
  'BusinessManagement' = 'businessManagement',
  /** Общее пользование территории **/
  'CommonUseArea' = 'commonUseArea',
  /** Высотная застройка **/
  'HighriseBuildings' = 'highriseBuildings',
  /** Гостиничное обслуживание **/
  'HotelAmenities' = 'hotelAmenities',
  /** Индивидуальное жилищное строительство (ИЖС) **/
  'IndividualHousingConstruction' = 'individualHousingConstruction',
  /** Промышленность **/
  'Industry' = 'industry',
  /** Отдых (рекреация) **/
  'Leisure' = 'leisure',
  /** Малоэтажное жилищное строительство (МЖС) **/
  'LowriseHousing' = 'lowriseHousing',
  /** Общественное использование объектов капитального строительства **/
  'PublicUseOfCapitalConstruction' = 'publicUseOfCapitalConstruction',
  /** Обслуживание автотранспорта **/
  'ServiceVehicles' = 'serviceVehicles',
  /** Торговые центры **/
  'ShoppingCenters' = 'shoppingCenters',
  /** Склады **/
  'Warehouses' = 'warehouses',
}
export enum EPlacementType {
  /** Помещение в торговом комплексе **/
  'ShoppingMall' = 'shoppingMall',
  /** Street retail **/
  'StreetRetail' = 'streetRetail',
}
export enum EPropertyType {
  /** здание **/
  'Building' = 'building',
  /** помещение свободного назначения **/
  'FreeAppointment' = 'freeAppointment',
  /** гараж **/
  'Garage' = 'garage',
  /** производство **/
  'Industry' = 'industry',
  /** земля **/
  'Land' = 'land',
  /** офис **/
  'Office' = 'office',
  /** торговая площадь **/
  'ShoppingArea' = 'shoppingArea',
  /** склад **/
  'Warehouse' = 'warehouse',
}
export enum EReadyBusinessType {
  /** Готовый бизнес (legacy значение, потом нужно отказаться) **/
  'Other' = 'other',
  /** Готовый бизнес **/
  'ReadyBusiness' = 'readyBusiness',
  /** Арендный бизнес **/
  'RentalBusiness' = 'rentalBusiness',
}
export enum ERepairType {
  /** Косметический **/
  'Cosmetic' = 'cosmetic',
  /** Дизайнерский **/
  'Design' = 'design',
  /** Евроремонт **/
  'Euro' = 'euro',
  /** Без ремонта **/
  'No' = 'no',
}
export enum ERoomType {
  /** Оба варианта **/
  'Both' = 'both',
  /** Смежная **/
  'Combined' = 'combined',
  /** Изолированная **/
  'Separate' = 'separate',
}
export enum EStatus {
  /** Заблокировано **/
  'Blocked' = 'blocked',
  /** Деактивировано **/
  'Deactivated' = 'deactivated',
  /** Удалено **/
  'Deleted' = 'deleted',
  /** Черновик **/
  'Draft' = 'draft',
  /** Промодерировано **/
  'Moderate' = 'moderate',
  /** Опубликовано **/
  'Published' = 'published',
  /** Отклонено **/
  'Refused' = 'refused',
  /** Удалено модератором **/
  'RemovedByModerator' = 'removedByModerator',
  /** Продано **/
  'Sold' = 'sold',
}
export enum EVasType {
  /** Классическое ранжирование **/
  'Classic' = 'classic',
  /** ML ранжирование **/
  'Ml' = 'ml',
}
export enum EWaterType {
  /** Автономное **/
  'Autonomous' = 'autonomous',
  /** Центральное **/
  'Central' = 'central',
  /** Водонапорная станция **/
  'PumpingStation' = 'pumpingStation',
  /** Водозаборный узел **/
  'WaterIntakeFacility' = 'waterIntakeFacility',
  /** Водонапорная башня **/
  'WaterTower' = 'waterTower',
}
export enum EWcLocationType {
  /** В доме **/
  'Indoors' = 'indoors',
  /** На улице **/
  'Outdoors' = 'outdoors',
}
export enum EWcType {
  /** Совмещенный **/
  'Combined' = 'combined',
  /** Раздельный **/
  'Separate' = 'separate',
}
export enum EWindowsViewType {
  /** На улицу **/
  'Street' = 'street',
  /** Во двор **/
  'Yard' = 'yard',
  /** На улицу и двор **/
  'YardAndStreet' = 'yardAndStreet',
}
